/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-scroll';
import firebase from 'firebase/app';
import Checkbox from '@material-ui/core/Checkbox';
import axios from 'axios';
import fb from 'firebaseConfig';
import { useSnackbar } from 'notistack';

import { getEula } from 'services/api/eula';
import { firebaseErrors } from 'services/api/firebaseErrors';

import BREAKPOINT from 'assets/styles/breakpoints';

import { Text } from 'components/Text';
import { Button } from 'components/Button';
import { ALERT_TYPE } from 'components/Alert';
import { Input, TextArea } from 'components/Input';
import { SimpleInputMask } from 'components/InputMask';
import SnackMessage, { OPTIONS } from 'components/SnackMessage';
import { BsCaretDownFill } from 'react-icons/bs';

import imgBackground from 'assets/images/phone-lp.png';
import Assecivil from 'assets/images/assecivil.png';

import logoForm from 'assets/icons/logo-form.svg';
import Detail5 from 'assets/icons/detail-5.svg';
import Detail6 from 'assets/icons/detail-6.svg';
import Detail7 from 'assets/icons/detail-7.svg';

import Deliverables from 'assets/icons/example-deliverables.svg';
import Facebook from 'assets/icons/logo-facebook.svg';
import Linkedin from 'assets/icons/logo-linkedin.svg';
import Twitter from 'assets/icons/logo-twitter.svg';

import EulaModal from 'pages/SignUp/EulaModal';
import CodeModal from 'pages/SignUp/CodeModal';
import MissingCodeModal from 'pages/SignUp/MissingCodeModal';
import EmailModal from 'pages/SignUp/EmailModal';

import Menu from 'pages/Landing/Menu';
import {
  Footer, Box,
  Faq, Contact,
  Wrapper, Hero,
  Content, SPCard,
  Container,
  Card, CheckBoxWrapper,
} from './styles';

const currentYear = new Date().getFullYear();

// Landing Page
const Landing = () => {
  const [user, setUser] = useState({
    phone: '',
    email: '',
    name: '',
    message: '',
  });
  const [complete, setComplete] = useState(false);
  const [eula, setEula] = useState({});
  const [checked, setChecked] = useState(false);
  const [openEula, setOpenEula] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openMissingModal, setMissingModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState(false);
  const [openEmailModal, setEmailModal] = useState(false);
  const [isPrivacy, setIsPrivacy] = useState(false);
  const isMobile = useMediaQuery({ query: `(max-width: ${BREAKPOINT.MD_2})` });

  const { enqueueSnackbar } = useSnackbar();

  // Config. para login por link de email
  const actionCodeSettings = {
    handleCodeInApp: true,
    url: `${process.env.REACT_APP_APP_URL}/login`,
  };

  const sendGridApiUrl = process.env.REACT_APP_API_EMAIL_URL;
  const sendGridKey = process.env.REACT_APP_SENDGRID_API_KEY;

  const resetRecaptcha = () => window.recaptchaVerifier.reset();

  const showModal = () => {
    if (openMissingModal) setMissingModal(false);
    setOpenModal(true);
  };

  const closeModal = () => {
    setLoading(false);
    setOpenModal(false);
    resetRecaptcha();
  };

  const showMissingModal = () => {
    if (openModal) setOpenModal(false);
    setMissingModal(true);
  };

  const closeMissingModal = () => {
    setLoading(false);
    setMissingModal(false);
    resetRecaptcha();
  };

  const showEmailModal = () => {
    setOpenModal(false);
    setEmailModal(true);
  };

  const closeEmailModal = () => {
    setLoading(false);
    setEmailModal(false);
  };

  // Carrega termos de uso
  const loadEula = async () => {
    try {
      const { data } = await getEula();
      setEula(data[0]);
    } catch (error) {
      // console.error(error);
      enqueueSnackbar('Erro ao carregar os Termos de Uso e a Política de Privacidade.', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            message={message}
            variant={ALERT_TYPE.ERROR}
          />
        ),
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setUser({
      ...user,
      [name]: value,
    });
  };

  // Login por link por email
  const handleSignWithEmail = async (e) => {
    e.preventDefault();

    try {
      await fb.auth().sendSignInLinkToEmail(user.email, actionCodeSettings);

      setComplete(true);

      localStorage.idEula = eula.id;
      localStorage.setItem('nameForSignIn', user.name);
      localStorage.setItem('emailForSignIn', user.email);
    } catch (error) {
      if (error.code) {
        enqueueSnackbar(firebaseErrors[error.code], {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
      }
    }
  };

  const handleCheck = (e) => {
    setChecked(e.target.checked);
  };

  const showEula = () => setOpenEula(true);

  const closeEula = () => setOpenEula(false);

  // Envio do form. de contato
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingMsg(true);

    const payload = {
      name: user.name,
      email: user.email,
      message: user.message,
      product: 'LOIT FGTS',
    };

    await axios.post(
      sendGridApiUrl,
      payload,
      {
        headers: {
          'X-API-KEY': sendGridKey,
        },
      },
    ).then(() => {
      setUser({
        ...user,
        name: '',
        email: '',
        message: '',
      });
      enqueueSnackbar('Mensagem enviada com sucesso!', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            message={message}
            variant={ALERT_TYPE.SUCCESS}
          />
        ),
      });
    }).catch(() => {
      enqueueSnackbar('Desculpe, ocorreu um erro ao enviar a mensagem!', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            message={message}
            variant={ALERT_TYPE.ERROR}
          />
        ),
      });
    }).finally(() => {
      setLoadingMsg(false);
    });
  };

  useEffect(() => {
    document.title = 'LOIT FGTS - Revisão monetária do seu FGTS';

    loadEula();

    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', { size: 'invisible' });
  }, []);

  // Exibe recaptcha e envia o código de verificação
  const handleSignUpWithPhone = async (e) => {
    e.preventDefault();

    if (checked) {
      setLoading(true);

      const { phone } = user;
      const appVerifier = window.recaptchaVerifier;

      try {
        const result = await fb.auth().signInWithPhoneNumber(phone, appVerifier);
        window.confirmationResult = result;

        // Exibe modal para inserir o código de verificação
        showModal();
      } catch (error) {
        // console.error(error);
        setLoading(false);
        resetRecaptcha();
        if (error.code) {
          enqueueSnackbar(firebaseErrors[error.code], {
            ...OPTIONS,
            content: (key, message) => (
              <SnackMessage
                id={key}
                message={message}
                variant={ALERT_TYPE.ERROR}
              />
            ),
          });
        }
      }
    } else {
      enqueueSnackbar('Para prosseguir é necessário estar de acordo com a Política de Privacidade.', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            message={message}
            variant={ALERT_TYPE.ERROR}
          />
        ),
      });
    }
  };

  // Completa o cadastro após confirmação do código de verificação
  const completeVerification = async (code) => {
    const { name } = user;

    setLoadingConfirm(true);

    try {
      await window.confirmationResult.confirm(code);

      await fb.auth().currentUser.updateProfile({
        displayName: name,
      });

      localStorage.session = 'true';
      localStorage.idEula = eula.id;
      localStorage.origin = 'assecivil';
      localStorage.events = JSON.stringify([
        '10 - cadastro assecivil',
        '20 - acesso',
        '30 - sms',
        '40 - código de acesso',
        '50 - primeiro acesso',
      ]);
    } catch (error) {
      if (error.code) {
        enqueueSnackbar(firebaseErrors[error.code], {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
      }
      resetRecaptcha();
    } finally {
      setLoading(false);
      setLoadingConfirm(false);
    }
  };

  // Reenvio do código de confirmação
  const retryVerification = async () => {
    closeMissingModal();

    setLoading(true);

    const { phone } = user;
    const appVerifier = window.recaptchaVerifier;

    try {
      const result = await fb.auth().signInWithPhoneNumber(phone, appVerifier);
      window.confirmationResult = result;

      // Exibe modal para inserir o código de verificação
      showModal();
    } catch (error) {
      setLoading(false);
      // console.error(error);
      if (error.code) {
        enqueueSnackbar(firebaseErrors[error.code], {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
      }
      resetRecaptcha();
    }
  };

  return (
    <Wrapper>
      {/* MODAL DE CÓDIGO DE CONFIRMAÇÃO */}
      <CodeModal
        phone={user.phone}
        open={openModal}
        onClose={closeModal}
        loading={loadingConfirm}
        showModal={showMissingModal}
        showEmailModal={showEmailModal}
        complete={completeVerification}
      />
      {/* MODAL DE CÓDIGO NÃO RECEBIDO */}
      <MissingCodeModal
        phone={user.phone}
        open={openMissingModal}
        retry={retryVerification}
        onClose={closeMissingModal}
      />
      {/* TERMOS DE USO */}
      <EulaModal
        data={eula}
        open={openEula}
        onClose={closeEula}
        isPrivacy={isPrivacy}
      />
      {/* MODAL DE LOGIN POR LINK DE EMAIL */}
      <EmailModal
        email={user.email}
        handleChange={handleChange}
        handleSubmit={handleSignWithEmail}
        open={openEmailModal}
        complete={complete}
        onClose={closeEmailModal}
      />
      {/* MENU */}
      <Menu assecivil />
      {/* HERO SECTION */}
      <Hero>
        <Container>
          <h1>Associado ASSECIVIL, descubra quanto você pode receber com a revisão monetária do seu FGTS!</h1>
          <h2>O acesso ao direito como escolha</h2>
          <Link activeClass="active" to="info-loit" spy smooth offset={isMobile ? -70 : -88} duration={1000}>
            <h3>
              Quer saber mais?
              <BsCaretDownFill />
            </h3>
          </Link>
          <Card hero>
            <img
              src={logoForm}
              alt="logo fgts"
              style={{
                position: 'initial',
              }}
            />
            <img
              className="assecivil"
              src={Assecivil}
              alt="Logo Assecicil"
              style={{
                position: 'initial',
              }}
            />
            <h4>Para iniciar, informe o seu número de celular</h4>
            <form onSubmit={handleSignUpWithPhone}>
              {/* Número do celular */}
              <SimpleInputMask
                icon
                required
                autoFocus
                name="phone"
                type="tel"
                value={user.phone}
                onChange={handleChange}
                mask="+55 (99) 9 9999-9999"
                placeholder="Número do celular"
                title="Insira o seu número de celular"
              />
              {/* Termos de Uso */}
              <CheckBoxWrapper>
                <Checkbox
                  id="eula"
                  size="small"
                  color="secondary"
                  checked={checked}
                  onChange={handleCheck}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
                <Text comment>
                  Ao continuar você declara ter lido e estar de acordo com nossos
                  {' '}
                  <a onClick={() => {
                    showEula();
                    setIsPrivacy(false);
                  }}
                  >
                    Termos de Uso
                  </a>
                  {' '}
                  e
                  {' '}
                  <a onClick={() => {
                    showEula();
                    setIsPrivacy(true);
                  }}
                  >
                    Política de Privacidade.
                  </a>
                </Text>
              </CheckBoxWrapper>
              <Button
                type="submit"
                loading={loading}
              >
                Calcular revisão
              </Button>
              {/* Reaptcha container */}
              <div id="recaptcha-container" />
            </form>
          </Card>
          <img src={imgBackground} alt="App do usuário" className="img-background" />
        </Container>
      </Hero>
      {/* INFO SOBRE O LOIT */}
      <Content info style={{ backgroundImage: `url(${Detail6})` }} id="info-loit">
        <Container info>
          <Box style={{ backgroundImage: `url(${Detail5})` }}>
            <h3>Conheça a LOIT FGTS </h3>
            <p>A LOIT FGTS é uma ferramenta que foi criada para facilitar a sua busca pelo direito de corrigir os seus saldos do FGTS! Oferecemos, gratuitamente, o valor do cálculo estimado a ser corrigido no seu saldo do FGTS, facilitando o acesso à Justiça e a busca pelo seu direito!</p>
            <p>Para isso, nós desenvolvemos um sistema automatizado que foi programado para ler os extratos do FGTS obtidos junto à Caixa Econômica Federal e apresentar o cálculo para você em poucos segundos.</p>
            <p>A partir do resultado, caso você tenha interesse em buscar a correção dos seus valores, é possível obter o nosso "Kit Correção FGTS”, que contém os Cálculos Revisionais e a Petição Inicial, que são os documentos necessários para solicitar a sua revisão no Juizado Especial Federal, juntos aos extratos do FGTS e os seus documentos pessoais.</p>
          </Box>
          <Box>
            <h3>Sobre a Revisão dos Saldos do FGTS</h3>
            <p>Se você trabalhou com carteira assinada em algum momento da vida, provavelmente tem uma ou mais contas de FGTS vinculadas ao seu nome (CPF ou PIS).</p>
            <p>Todos os meses os saldos dessas contas são corrigidos monetariamente pelo Índice da Caderneta de Poupança (TR).</p>
            <p>Desde 1999, a TR não tem acompanhado a inflação, trazendo perdas financeiras para os titulares das contas de FGTS.</p>
          </Box>
          <Box>
            <h3>Quem pode se beneficiar com a Revisão?</h3>
            <p>Todas as pessoas que mantiveram, durante o período de 1999 até hoje, algum contrato de trabalho em regime CLT, contribuindo com o Fundo de Garantia por Tempo de Serviço (FGTS), podem pedir revisão pleiteando a diferença na justiça.</p>
            <p>Mesmo quem já efetuou o saque da conta pode solicitar a revisão dos saldos, pois, o direito está vinculado ao longo do período e você pode reaver as diferenças que foram perdidas.</p>
          </Box>
        </Container>
      </Content>
      {/* FAQ */}
      <Container className="wrapper">
        <Faq style={{ backgroundImage: `url(${Detail7})` }}>
          <div>
            <h3>Dúvidas frequentes</h3>
            <ul>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://ajuda.tikal.tech/pt-BR/articles/4844402-quais-documentos-sao-necessarios-para-o-calculo"
                >
                  Quais documentos são necessários?
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://ajuda.tikal.tech/pt-BR/articles/4844117-como-posso-dar-entrada-no-processo"
                >
                  Como posso dar entrada no processo?
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://ajuda.tikal.tech/pt-BR/articles/4844488-qual-e-a-situacao-da-tese-no-tribunal"
                >
                  Qual é a situação da Tese no Tribunal?
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://ajuda.tikal.tech/pt-BR/articles/4844429-o-que-a-loit-fgts-oferece"
                >
                  O que a LOIT FGTS oferece?
                </a>
              </li>
            </ul>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://ajuda.tikal.tech/pt-BR/collections/2748191-loit-fgts"
            >
              <Button>Consultar FAQ</Button>
            </a>
          </div>
        </Faq>
        <Contact>
          <h3>Entenda o Kit com a Petição e o Cálculo</h3>
          <SPCard>
            <p>A petição inicial contém seus dados pessoais e demonstra seu direito, com fundamentos jurídicos simples e diretos. A planilha de cálculo permite que você apresente para o Juiz uma estimativa do quanto seu FGTS perdeu valor de compra com o passar dos anos.</p>
            <img src={Deliverables} alt="Exemplo de entregáveis" />
          </SPCard>
        </Contact>
      </Container>
      {/* Contato */}
      <Contact form>
        <h3>Entre em contato e tire as suas dúvidas</h3>
        <Container className="wrapper">
          <div>
            <form onSubmit={handleSubmit}>
              {/* Nome */}
              <Input
                icon
                required
                name="name"
                value={user.name}
                onChange={handleChange}
                type="text"
                placeholder="Nome"
              />
              {/* E-mail */}
              <Input
                icon
                required
                name="email"
                type="email"
                value={user.email}
                onChange={handleChange}
                placeholder="E-mail"
              />
              {/* Mensagem */}
              <TextArea
                required
                name="message"
                value={user.message}
                onChange={handleChange}
                placeholder="Digite sua mensagem..."
              />
              <Button
                type="submit"
                loading={loadingMsg}
              >
                Enviar mensagem
              </Button>
            </form>
          </div>
          {/* Mídia Social */}
          <div>
            <h4>Estamos nas mídias</h4>
            <ul className="social">
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.facebook.com/tikaltech/"
                >
                  <img src={Facebook} alt="Facebook" title="Facebook" />
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.linkedin.com/company/tikal-tech/"
                >
                  <img src={Linkedin} alt="LinkedIn" title="LinkedIn" />
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://twitter.com/tikaltech"
                >
                  <img src={Twitter} alt="Twitter" title="Twitter" />
                </a>
              </li>
            </ul>
            <ul>
              {/* <li>
                WhatsApp:&nbsp;
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://api.whatsapp.com/send?phone=5548996017254"
                >
                  (48) 99601-7254
                </a>
              </li> */}
              <li>
                <a href="mailto:atendimento@loitlegal.com.br">
                  atendimento@loitlegal.com.br
                </a>
              </li>
            </ul>
          </div>
        </Container>
      </Contact>
      {/* Rodapé */}
      <Footer>
        <h4>LOIT FGTS é um produto TIKAL TECH</h4>
        <p>
          ©
          {' '}
          {currentYear}
          {' '}
          TIKAL TECH - Tia Tikal Inteligência Artificial LTDA - CNPJ: 22.125.577/0001-62
        </p>
        <address>Av. Queiroz Filho, 1700 - São Paulo - SP, CEP 05319-000</address>
      </Footer>
    </Wrapper>
  );
};

export default Landing;
